var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.qr)?_c('figure',{staticClass:"text-center"},[_c('img',{attrs:{"src":_vm.qr,"alt":"Qr code"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }